// ECDEX-3840 (slice 4, MR 2b): what the query cache holds for a verification.
// The fetch fills it, and a submit or an unsubscribe replaces its
// `verification`. `steps` and `expired` come with the fetch and are not
// recomputed from a submit response: that would change the steps the candidate
// is part way through.
export interface VerificationCacheData {
  // As the API returned it (camelized). Its shape depends on `object`, and the
  // screens read it as `any`, as they did from the slice.
  verification: any;
  steps: any[];
  expired: boolean;
}

// The verification id a page's URL asks for: hex characters only, at most 24.
// Status fetches with this, and the verification components compare against it.
export const normalizeVerificationId = (rawId?: string) =>
  rawId?.replaceAll(/[^a-fA-F0-9]/g, '').slice(0, 24);

export const verificationQueryKey = (verificationId?: string) => [
  'verification',
  verificationId,
];

// The mutation key of a verification submit, so the provider can tell that one
// is running.
export const VERIFICATION_SUBMIT_MUTATION_KEY = ['verification', 'submit'];

// While the `verifications` slice still exists (until slice 4 is done) it is
// where the thunks put their result. This is that result, as cache data.
export const verificationCacheDataFromSlice = (
  slice: any,
): VerificationCacheData | null =>
  slice?.verification
    ? {
        verification: slice.verification,
        steps: slice.steps ?? [],
        expired: slice.expired ?? false,
      }
    : null;
